// src/app/Distributor.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Distributor } from  '../objects/Distributor';
import { environment } from '../environments/environment';  

@Injectable({
  providedIn: 'root',
})
export class DistributorService {
    
  private apiUrl = environment.apiUrl +'Distributors'; // Replace with your API endpoint

  constructor(private http: HttpClient) {}

  GetDistributor(): Observable<Distributor[]> {
    return this.http.get<Distributor[]>(this.apiUrl);
  }

  
  getDistributor(id:number): Observable<Distributor> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<Distributor>(url);
  }



  addDistributor(distributor: Distributor): Observable<Distributor> {
    return this.http.post<Distributor>(this.apiUrl, distributor);
  }

  editDistributor(distributor: Distributor): Observable<Distributor> {
    const url = `${this.apiUrl}/${distributor.id}`;
    return this.http.put<Distributor>(url, distributor);
  }

  deleteDistributor(distributor: Distributor): Observable<Distributor> {
    const url = `${this.apiUrl}/${distributor.id}`;
    return this.http.delete<Distributor>(url);
  }
}
